export default {
    general: {
        add:      'Dodaj',
        edit:     'Uredi',
        cancel:   'Prekliči',
        save:      'Shrani',
        sign_out:  'Odjava',
        more_info: 'Več informacij',   // AppInfoTip's aria-label
        ni_podatkov: 'Ni podatkov.',
    },
    // Used by the shell templates (step 19)
    brand: {
        product_name: 'Blisk BI',
        tagline:      'Poslovni pregledi',
    },
    nav: {
        group_overviews:    'Pregledi',
        overview:           'Pregled',
        projects:           'Projekti',
        data_quality:       'Kakovost podatkov',
        revenue_costs:      'Prihodki in stroški',
        cash_flow:          'Denarni tok',
        payment_discipline: 'Plačilna disciplina',
        imports:            'Uvozi',
        group_bmapp:        'BMapp',
        project_progress:   'Napredek projektov',
        teams:              'Ekipe',
        sales:              'Prodaja',
    },
    layout: {
        open_menu:  'Odpri meni',
        close_menu: 'Zapri meni',
    },
    color_mode: {
        switch_to_light: 'Preklopi na svetli način',
        switch_to_dark:  'Preklopi na temni način',
    },
    errors: {
        generic_error: 'Prišlo je do napake',
        invalid_data:  'Neveljavni podatki',
        not_found:     'Ni najdeno',
        unauthorized:  'Ni pooblastila',
        neveljaven_izvoz: 'Neveljaven izvoz',
        ni_podatkov:   'Ni podatkov',
        ni_dostopa:    'Ni dostopa',
        prevec_zahtevkov: 'Preveč zahtevkov, poskusi pozneje',
        bmapp_izklopljen: 'Podatki BMapp niso na voljo',
        nastavitve_spremenjene: 'Nastavitve je medtem spremenil drug uporabnik, osveži.',
        on_add:        'Napaka pri dodajanju',
        on_edit:       'Napaka pri posodabljanju',
    },
    success: {
        add:  'Uspešno dodano',
        edit: 'Uspešno posodobljeno',
    },
    validation: {
        required: 'To polje je obvezno',
        email:    'Neveljaven e-naslov',
    },
    prijava: {
        naslov:   'Prijava',
        z_bmapp:  'Prijava z BMapp',
        koncujem: 'Zaključujem prijavo …',
        napaka:   'Prijava ni uspela. Poskusi znova.',
        prevec_poskusov: 'Preveč poskusov prijave. Poskusi znova čez minuto.',
    },
    ni_dostopa: {
        naslov:   'Ni dostopa',
        besedilo: 'Do BI nimaš dostopa. Če ga potrebuješ, se obrni na Jako Baniča.',
    },
    // Imena izvozov ERP (README, »Tedenski uvoz«)
    viri: {
        pokalkulacija_dn:     'Pregled DN – pokalkulacija',
        pregled_konta:        'Pregled konta',
        kartica_kupcev:       'Konto kartica kupca',
        kartica_dobaviteljev: 'Konto kartica dobavitelja',
        bmapp_projekti:       'BMapp – projekti',
        bmapp_zasedenost:     'BMapp – zasedenost',
        bmapp_uspesnost:      'BMapp – uspešnost ponudb',
    },
    vir_izvozov: {
        vrstica: '{vir}: {datoteka} (uvoženo {datum})',
        manjka:  'Za {vir} še ni uvoza — podatki so nepopolni.',
    },
    // Strani s tabelami (faza C1.4). Razlage (info) so besedila iz načrta, ostalo je delo C1.4.
    projekti: {
        samo_najvecji: 'Samo {n} največjih',
        info: 'Rezultat GK uporablja material iz glavne knjige (pravi podatek), rezultat DN material z delovnih nalogov. Delo je ure × cena ure.',
        stolpci: {
            sn:                 'SN',
            naziv:              'Naziv',
            stevilo_dn:         'DN (št.)',
            izdani_racuni:      'Izdani računi',
            material_gk:        'Material (GK)',
            material_dn:        'Material (DN)',
            razlika_materiala:  'Razlika materiala',
            delo:               'Delo',
            tuje_storitve:      'Tuje storitve',
            ostalo:             'Ostalo',
            rezultat_gk:        'Rezultat (GK)',
            rezultat_dn:        'Rezultat (DN)',
            porabljene_ure:     'Porabljene ure',
            pogodbena_vrednost: 'Pogodbena vrednost',
        },
    },
    kakovost: {
        skupaj: 'Skupaj',
        sn_samo_gk: {
            naslov: 'SN samo v glavni knjigi',
            info:   'SN z vsaj eno knjižbo, ki ga ni v nobeni vrstici DN (vključno z režijskimi).',
        },
        sn_samo_dn: {
            naslov: 'SN samo v DN',
            info:   'SN v DN (brez režije), brez knjižb v glavni knjigi.',
        },
        razlike_materiala: {
            naslov: 'Razlike materiala DN ↔ GK',
            info:   'Projekti z razliko materiala vsaj 1 cent, po velikosti razlike.',
        },
        stroski_brez_sn: {
            naslov: 'Stroški brez SN',
        },
        cena_ure_odstopa: {
            naslov: 'Cena ure odstopa',
            info:   'Delovni nalogi, kjer delo ni enako urom × ceni ure (odstopanje več kot 1 cent).',
        },
        stolpci: {
            sn:          'SN',
            naziv:       'Naziv',
            stroski:     'Stroški',
            prihodki:    'Prihodki',
            material_gk: 'Material (GK)',
            material_dn: 'Material (DN)',
            razlika:     'Razlika',
            konto:       'Konto',
            znesek:      'Znesek',
            dn:          'DN',
            delo:        'Delo',
            ure:         'Ure',
            cena_ure:    'Cena ure',
        },
    },
    prihodki_stroski: {
        rezultat_po_mesecih: 'Rezultat po mesecih',
        rezultat_po_mesecih_sm: 'Rezultat po mesecih ({sm})',
        sm_oznaka: 'SM {sm}',
        info:    'Prihodki so konti 76xx, stroški razred 4 — to ni poslovni izid (EBIT).',
        sm:      'SM',
        vse:     'Vse',
        brez_sm: 'Brez SM',
        skupaj:  'Skupaj',
        stolpci: {
            mesec:    'Mesec',
            sm:       'SM',
            prihodki: 'Prihodki (76xx)',
            stroski:  'Stroški (razred 4)',
            razlika:  'Razlika',
        },
    },
    denarni_tok: {
        prilivi_in_odlivi: 'Prilivi in odlivi po tednih',
        info:    'Dejanska plačila iz konto kartic; ročna zapiranja (PIFA) niso vključena. Ni napoved.',
        skupaj:  'Skupaj',
        stolpci: {
            teden:   'Teden (KT)',
            od:      'Od',
            prilivi: 'Prilivi',
            odlivi:  'Odlivi',
            neto:    'Neto',
        },
    },
    disciplina: {
        info:        'Samo plačila, ki se enolično vežejo na en račun. Negativni dnevi = plačano pred rokom. Staranje odprtih postavk pride z izvozom odprtih postavk.',
        kupci:       'Kupci',
        dobavitelji: 'Dobavitelji',
        povezanih:   'Povezanih plačil',
        mediana:     'Mediana dni od zapadlosti',
        p25:         'P25 (dni)',
        p75:         'P75 (dni)',
        delez:       'Delež po zapadlosti',
    },
    uvozi: {
        preberi:        'Preberi mapo zdaj',
        osvezi_bmapp:   'Osveži iz BMapp',
        osvezi_uspelo:  'Osveženo iz BMapp: uspešnih {uspesnih}, napak {napak}',
        osvezi_napake:  'Osvežitev iz BMapp: napak {napak} (glej tabelo uvozov)',
        preberi_uspelo: 'Uvoženih: {uvozenih}, preskočenih: {preskocenih}, napak: {napak}',
        stanje: {
            v_teku:  'V teku',
            uspesno: 'Uspešno',
            napaka:  'Napaka',
        },
        stolpci: {
            uvozeno:  'Uvoženo',
            vir:      'Vir',
            datoteka: 'Datoteka',
            vrstic:   'Vrstic',
            stanje:   'Stanje',
            napaka:   'Napaka',
        },
    },
    // Strani BMapp (faza F1)
    bmapp: {
        ni_prebrano:     'Podatki BMapp še niso prebrani.',
        stanje:          'Stanje BMapp: {datum}',
        odrezano:        'Seznam ponudb je odrezan: prikazani so samo prebrani izidi, podatki so nepopolni.',
        skupaj:          'Skupaj',
        ne_osvezuje:     'BMapp ni nastavljen: podatki se ne osvežujejo.',
    },
    napredek: {
        info:            'Napredek projektov iz BMapp: aktivni projekti (v pripravi, v izvajanju). Konec po ekipi upošteva razpoložljivost ekipe, konec po tempu dosedanji učinek dela.',
        portfelj:        'Portfelj',
        portfelj_info:   'Neopravljeno = vsota max(0, načrtovano − opravljeno) aktivnih projektov. Mesečna kapaciteta = povprečna tedenska razpoložljivost 12 tednov × 52 / 12. Meseci dela = pričakovane ure / mesečna kapaciteta.',
        predlog:         'predlog definicije, potrdi Simona',
        neopravljeno:    'Neopravljeno',
        pricakovane_ure: 'Pričakovane ure',
        meseci_dela:     'Meseci dela',
        brez_napovedi:   'Projektov brez napovedi',
        vir_zasedenosti: 'Zasedenost za portfelj: {datum}',
        brez_zasedenosti:'Portfelj ni izračunan: zasedenost BMapp še ni prebrana.',
        stolpci: {
            sifra:         'Šifra',
            naziv:         'Naziv',
            stranka:       'Stranka',
            vodja:         'Vodja',
            rok:           'Rok',
            napredek:      'Napredek',
            nacrtovano:    'Načrtovano',
            opravljeno:    'Opravljeno',
            obracunano:    'Obračunano',
            nezaracunano:  'Nezaračunano',
            konec_ekipa:   'Konec po ekipi',
            rezerva_ekipa: 'Rezerva po ekipi',
            rezerva_tempo: 'Rezerva po tempu',
            konec_tempo:   'Konec po tempu',
        },
        rezerva_dni:     '{n} d',
        vrednost:        'vrednost',
        norma:           'norma',
        ure:             'ure',
    },
    ekipe: {
        izkoriscenost_po_tednih: 'Izkoriščenost po tednih',
        info:            'Izkoriščenost = dodeljeno / razpoložljivo. Razpoložljivo so delovni dnevi brez praznikov in odobrenega dopusta.',
        tednov:          'Število tednov',
        tednov_n:        'Tednov: {n}',
        manjka_tednov:   'BMapp je vrnil manj tednov, kot je izbranih: {dobljeno} od {izbrano}.',
        po_tednih:       'Ekipa po tednih',
        po_osebah:       'Osebe po tednih',
        stolpci: {
            teden:          'Teden',
            razpolozljivo:  'Razpoložljivo',
            dodeljeno:      'Dodeljeno',
            izkoriscenost:  'Izkoriščenost',
            brez_dodelitve: 'Brez dodelitve',
            oseba:          'Oseba',
            povprecje:      'Povprečje',
        },
    },
    prodaja: {
        info:            'Izidi ponudb po mesecih izida. Delež = dobljenih / (dobljenih + izgubljenih); »ne oddamo« se ne šteje.',
        stolpci: {
            mesec:                'Mesec',
            dobljenih:            'Dobljenih',
            izgubljenih:          'Izgubljenih',
            ne_oddamo:            'Ne oddamo',
            delez:                'Delež dobljenih',
            vrednost_dobljenih:   'Vrednost dobljenih',
            vrednost_izgubljenih: 'Vrednost izgubljenih',
        },
    },
    // Lastni grafi SVG (faza C2.5): opisi za bralnike zaslona in besedila semaforja.
    grafi: {
        ni_podatka:         'ni podatka',
        ni_podatkov:        'Ni podatkov.',
        povzetek:           'Od {od} do {do}: {n} točk. Prva {prva}, zadnja {zadnja}, najnižja {najnizja} ({kdajNajnizja}), najvišja {najvisja} ({kdajNajvisja}).',
        brez_podatka_stevilo: 'Točk brez podatka: {n}.',
        legenda:            'Legenda',
        navigacija:         'Puščici levo in desno premakneta izbiro točke.',
        semafor: {
            zelena: 'zeleno',
            rumena: 'rumeno',
            rdeca:  'rdeče',
            brez:   'brez meje',
        },
    },
    // Prva stran (faza C2.6): imena in opisi kazalnikov kataloga (`pkg/Kazalniki/katalog.go`) po id-ju.
    kazalniki: {
        rezultat_leto: {
            ime:  'Rezultat tekočega leta',
            opis: 'Razlika med prihodki 76xx in stroški razreda 4 tekočega leta. To ni EBIT.',
        },
        prihodki_leto: {
            ime:  'Prihodki tekočega leta',
            opis: 'Vsota prihodkov tekočega leta.',
        },
        stroski_leto: {
            ime:  'Stroški tekočega leta',
            opis: 'Vsota stroškov tekočega leta.',
        },
        prilivi_4_tedni: {
            ime:  'Prilivi zadnjih 4 tednov',
            opis: 'Vsota prilivov zadnjih 4 zaključenih tednov.',
        },
        odlivi_4_tedni: {
            ime:  'Odlivi zadnjih 4 tednov',
            opis: 'Vsota odlivov zadnjih 4 zaključenih tednov.',
        },
        stroski_brez_dn: {
            ime:  'Stroški brez delovnega naloga',
            opis: 'Stroški razreda 4 brez šifre naloga (SN); kazalnik kakovosti knjiženja. Znesek je čez celoten uvožen pregled konta, ne le za tekoče leto (kot stran Kakovost podatkov).',
        },
        napredek_skupaj: {
            ime:  'Napredek projektov v izvajanju',
            opis: 'Vsota opravljenega, deljena z vsoto načrtovanega za projekte v izvajanju.',
        },
        nezaracunano: {
            ime:  'Nezaračunano',
            opis: 'Vsota nezaračunanih zneskov projektov v izvajanju.',
        },
        portfelj_neopravljeno: {
            ime:  'Portfelj: neopravljeno delo',
            opis: 'Neopravljeno delo (vrednost) projektov v pripravi in izvajanju. Predlog definicije, še ni potrjena.',
        },
        portfelj_meseci: {
            ime:  'Portfelj: meseci dela',
            opis: 'Meseci dela portfelja glede na mesečno kapaciteto ekipe. Predlog definicije, še ni potrjena.',
        },
        izkoriscenost_4_tedni: {
            ime:  'Izkoriščenost naslednjih 4 tednov',
            opis: 'Vsota dodeljenega, deljena z vsoto razpoložljivega časa v naslednjih 4 tednih.',
        },
        delez_dobljenih_12m: {
            ime:  'Delež dobljenih ponudb (12 mesecev)',
            opis: 'Dobljeni, deljeni z vsoto dobljenih in izgubljenih v zadnjih 12 mesecih.',
        },
        projekti_negativna_rezerva: {
            ime:  'Projekti z negativno rezervo',
            opis: 'Število projektov v izvajanju z rezervo po ekipi pod nič; brez napovedi po ekipi velja rezerva po tempu.',
        },
    },
    // Prva stran: kartice, urejanje in zgodovina sprememb.
    pregled: {
        uredi:          'Uredi prvo stran',
        zgodovina:      'Zgodovina sprememb',
        prazno:         'Prva stran nima kartic. Dodaj jih z »Uredi prvo stran«.',
        nalaganje:      'Nalaganje prve strani …',
        predlog:        'predlog definicije',
        razlog_bmapp:   'Podatki BMapp še niso prebrani',
        razlog_erp:     'Ni uvoza izvozov ERP',
        razlog_izracun: 'Vrednosti ni mogoče izračunati',
        stanje:         'Stanje na dan {datum}',
        odgovoren:      'Odgovoren: {ime}',
        trend:          'Trend: {ime}',
        info_enota:     'Enota: {enota}',
        info_vir:       'Vir: {vir}',
        info_smer:      'Smer: {smer}',
        enote: {
            centi:           'evri',
            bp:              'odstotki',
            tisocinke_ure:   'ure',
            stevilo:         'število',
            stotinke_meseca: 'meseci',
        },
        viri: {
            erp:   'izvozi ERP',
            bmapp: 'BMapp',
        },
        smer: {
            visje: 'višje je bolje',
            nizje: 'nižje je bolje',
        },
        urejanje: {
            naslov:         'Uredi prvo stran',
            kartice:        'Kartice',
            brez_kartic:    'Ni kartic. Dodaj kazalnik.',
            gor:            'Premakni gor',
            dol:            'Premakni dol',
            odstrani:       'Odstrani kartico',
            odgovoren:      'Odgovoren',
            cilj:           'Cilj',
            meja_rdece:     'Meja rdečega',
            predogled:      'Predogled barve',
            primer:         'npr. {vrednost}',
            brez_vrednosti: 'Brez trenutne vrednosti kazalnik nima barve.',
            dodaj_naslov:   'Dodaj kazalnik',
            dodaj_izberi:   'Izberi kazalnik',
            dodaj:          'Dodaj',
            vsi_dodani:     'Vsi kazalniki so že na strani.',
            najvec_kartic:  'Največ {n} kartic.',
            shranjeno:      'Prva stran je shranjena.',
            napaka_preveri: 'Popravi označena polja.',
        },
        napake: {
            predolg:    'Največ {n} znakov.',
            neveljavno: 'Neveljavna vrednost.',
            skupaj:     'Cilj in meja rdečega morata biti izpolnjena oba ali noben.',
            visje:      'Pri »višje je bolje« mora biti cilj nad mejo rdečega.',
            nizje:      'Pri »nižje je bolje« mora biti cilj pod mejo rdečega.',
            smer:       'Neznana smer kazalnika.',
        },
        zgodovina_stran: {
            naslov:         'Zgodovina sprememb',
            prazno:         'Ni zabeleženih sprememb.',
            dodana:         'Dodana kartica »{ime}«',
            odstranjena:    'Odstranjena kartica »{ime}«',
            vrstni_red:     'Spremenjen vrstni red kartic',
            odgovoren:      '»{ime}«: odgovoren {prej} → {potem}',
            ni_odgovornega: 'ni nastavljen',
            meje:           '»{ime}«: meje {prej} → {potem}',
            meje_oblika:    'cilj {cilj}, meja rdečega {meja}',
            brez_mej:       'brez mej',
            brez_razlik:    'Brez vsebinskih sprememb (shranjeno nespremenjeno)',
            verzija:        'verzija {n}',
        },
    },
}
